import propz from 'propz';
import { ProgrammeBookingInboxItem } from 'Src/views/GenericView/components/ClubProgrammes/ProgrammeBooking/ProgrammeBooking.types';
import { ProgrammeRow } from './ParentClubProgrammes.types';

export function mergeProgrammeInboxItems(items: ProgrammeBookingInboxItem[]): ProgrammeBookingInboxItem[] {
  const byId = new Map<string, ProgrammeBookingInboxItem>();

  items.forEach(p => {
    const id = String(propz.get(p, ['id'], ''));
    if (!id) return;

    if (!byId.has(id)) {
      byId.set(id, p);
      return;
    }

    const prev = byId.get(id)!;
    const prevIds = propz.get(prev, ['children', 'childPermissionIds'], []) || [];
    const nextIds = propz.get(p, ['children', 'childPermissionIds'], []) || [];
    const merged = Array.from(new Set([...(prevIds || []), ...(nextIds || [])].map(String)));
    const previousStats = propz.get(prev, ['children', 'statsByPermissionId'], {}) || {};
    const nextStats = propz.get(p, ['children', 'statsByPermissionId'], {}) || {};

    byId.set(id, {
      ...prev,
      children: { childPermissionIds: merged, statsByPermissionId: { ...previousStats, ...nextStats } }
    });
  });

  return Array.from(byId.values());
}

export function buildProgrammeRows(
  items: ProgrammeBookingInboxItem[],
  childNameByPermId: Map<string, string>
): ProgrammeRow[] {
  return items.map(p => {
    const permIds: string[] = (propz.get(p, ['children', 'childPermissionIds'], []) || []).map(String);

    const childButtons = permIds.map(permissionId => ({
      permissionId,
      label: childNameByPermId.get(permissionId) || permissionId
    }));

    return { ...p, childButtons };
  });
}

export function sortProgrammeRows(rows: ProgrammeRow[]): ProgrammeRow[] {
  return rows.slice().sort((a, b) => {
    const aOp = propz.get(a, ['booking', 'opensAt'], null);
    const bOp = propz.get(b, ['booking', 'opensAt'], null);
    const at = aOp ? new Date(aOp).getTime() : 9999999999999;
    const bt = bOp ? new Date(bOp).getTime() : 9999999999999;

    if (at !== bt) return at - bt;

    const an = String(a.name || '').toLowerCase();
    const bn = String(b.name || '').toLowerCase();

    if (an < bn) return -1;
    if (an > bn) return 1;
    return 0;
  });
}

